<template>
  <label class="bx-switch-dark">
    <input
      :disabled="disabled"
      type="checkbox"
      :checked="value"
      @input="onInput"
      ref="input"
    />
    <div class="check"></div>
    <span class="bx-switch-label">
      <slot></slot>
    </span>
  </label>
</template>
<script>
export default {
  name: "bx-switch-dark",
  props: {
    value: {
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput() {
      this.$emit("input", this.$refs.input.checked);
    }
  }
};
</script>
